import BaseApi from './base.api'

export default {
    ...BaseApi,
    ...{
        resource: 'academic-years'
    }
}
